import axios from "axios";
const domain = 'https://back-end-preprod.nispand.com/v2'

export const postCousreApi = (payload) => {
  return axios.post(`${domain}/course`, payload)
}

export const getAllSupportAdvisorApi = () => {
  return axios.get(`${domain}/supportAdvisor`)
}

export const getAllLessonApi = () => {
  return axios.get(`${domain}/lesson/?isDisabled=false&isPublished=true`)
}

export const getAllPublishedCourseApi = ({ pubType, page, limit }) => {
  return axios.get(`${domain}/course?isPublished=${pubType}&page=${page}&limit=${limit}`)
}

export const updateUnpublishCourseApi = (id) => {
  return axios.patch(`${domain}/course/unpublish/${id}`)
}

export const updatePublishCourseApi = (id) => {
  return axios.patch(`${domain}/course/publish/${id}`)
}

export const getCourseByIdApi = (courseId) => {
  return axios.get(`${domain}/course/byId/${courseId}`)
}

export const updateCourseApi = (id, payload) => {
  return axios.put(`${domain}/course/update/${id}`, payload)
}

export const getAllFaq = () => {
  return axios.get(`${domain}/faq/getAllFaq/COURSE`)
}

export const getAllTags = () => {
  return axios.get(`${domain}/mediatags/get?objectType=TAG&page=1&limit=4000`)
}